// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs-module--breadcrumbs--38UkO"};